import {optionalMaterialInput, optionalPhysicalMaterialInput} from "#material/nodes/base/connection/validation/parameters"
import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {ExchangeNodeName} from "#material/exchange/node-name"
import {materialClosureOutput} from "#material/nodes/base/material/validation/io"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {z} from "zod/v4-mini"

export interface MixShaderSockets extends MaterialNodeSockets {
    inputs: {
        fac: "float" // found in inputs: float,color; found in settings: float; inferred from data: float
        shader: "closure" // found in inputs: closure; found in settings: -; inferred from data: -
        shader_001: "closure" // found in inputs: closure; found in settings: -; inferred from data: -
    }
    settings: {
        fac: "float" // found in inputs: float,color; found in settings: float; inferred from data: float
    }
    outputs: {
        shader: "closure"
    }
}

export const mixShaderDefinition = {
    exchangeFormat: {
        nodeName: ExchangeNodeName.ShaderNodeMixShader,
    },
    nodeClass: "MixShader",
    ui: {
        label: "Mix Shader",
        color: "#4987af",
        items: [
            {name: "shader", valueType: "closure", label: "Shader", output: true},
            {name: "shader", valueType: "closure", label: "Shader", input: true, setting: false},
            {name: "shader_001", valueType: "closure", label: "Shader", input: true, setting: false},
            {name: "fac", valueType: "float", label: "Fac", input: true, setting: true, defaultValue: 0.5},
        ],
        support: {
            cycles: true,
            three: true,
        },
    },
    validation: {
        returns: z.strictObject({
            shader: materialClosureOutput,
        }),
        parameters: z.strictObject({
            inputs: z.strictObject({
                shader: optionalPhysicalMaterialInput,
                shader_001: optionalMaterialInput,
                fac: optionalMaterialInput,
            }),
            settings: z.strictObject({
                fac: z.optional(z.number()),
            }),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<MixShaderSockets>
